// test1086
(1086 && 0);
